import logger from '../utils/logger';
/**
 * Hook personnalisé pour gérer les factures Stripe
 */

import { useState, useEffect } from 'react';
import { authFetch } from '@/utils/api-headers';
import { API_URL } from '@/lib/config';

export interface Invoice {
  id: string;
  amount_paid: number;
  amount_due: number;
  currency: string;
  status: string;
  created: number;
  period_start: number;
  period_end: number;
  invoice_pdf?: string;
  hosted_invoice_url?: string;
  number?: string;
}

export function useInvoices() {
  const [invoices, setInvoices] = useState<Invoice[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const load = async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await authFetch(`${API_URL}/api/billing/invoices`);

      if (response.ok) {
        const data = await response.json();
        setInvoices(data.invoices || []);
      } else {
        throw new Error('Failed to load invoices');
      }
    } catch (err: any) {
      logger.error('Error loading invoices:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  return {
    invoices,
    loading,
    error,
    reload: load,
  };
}

